import type { RouteRecordRaw, Router } from 'vue-router'

const EndowmentContractRoutes: RouteRecordRaw = {
  path: '/contract/estate/endowment',
  name: 'EndowmentEstateModulePages',
  redirect: { name: '' },
  children: [
    {
      path: '',
      name: 'EndowmentEstateMainRoute',
      component: () => import('./views/EndowmentView.vue'),
      meta: {
        title: 'endowmentEstate.endowmentContract',
      },
    },
    {
      path: 'create',
      name: 'EndowmentEstateCreateRoute',
      component: () => import('./views/EndowmentUpsertView.vue'),
      meta: {
        title: 'endowmentEstate.createEndowmentContract',
        pageHasBack: true,
      },
    },
    {
      path: 'edit/:endowmentId',
      name: 'EndowmentEstateEditRoute',
      component: () => import('./views/EndowmentUpsertView.vue'),
      meta: {
        title: 'endowmentEstate.editEndowmentContract',
        pageHasBack: true,
      },
    },
    {
      path: 'view/:endowmentId',
      name: 'ViewEndowmentEstateRoute',
      component: () => import('./views/SingleEndowmentView.vue'),
      meta: {
        title: 'endowmentEstate.ViewEndowment',
        pageHasBack: true,
      },
    },
  ],
  meta: {
    layout: 'Default',
  },
}

export default (router: Router) => {
  router.addRoute(EndowmentContractRoutes)
}
